import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Backward.svg",
  "use": "Backward.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Backward.svg\"><path d=\"M52.01,39.0209H32.0216v8.0113A2.0031,2.0031,0,0,1,28.7363,48.57L10.71,33.5574a2.0009,2.0009,0,0,1,0-3.0753L28.7363,15.47a2.0031,2.0031,0,0,1,3.2853,1.5377v8.013H52.01a2,2,0,0,1,2,2v10A2,2,0,0,1,52.01,39.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol